<template>
  <p class="guest-auth-prompt">
    <router-link :to="{ name: 'login', query: { redirect: redirectPath } }">Войдите</router-link>,
    чтобы ставить реакции, добавлять в избранное и комментировать.
  </p>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const redirectPath = computed(() => route.fullPath)
</script>

<style scoped>
.guest-auth-prompt {
  margin: 1rem 0 0;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  background: #eef2ff;
  color: #3730a3;
}
</style>
